import { IDoorProxy } from 'models/contact_companies'
import { DataTypeColumn } from '../Common/commonColumnHelpers'
import { COMMON_COLUMNS } from '../Common/CommonColumnsInfo'

export const UNMATCHED_DOORS_COLUMNS = {
  name: {
    header: 'Name',
    group: 'Opportunity Attributes',
    tooltipName: 'name',
  },
  domain: {
    header: 'Domain',
    group: 'Opportunity Attributes',
    tooltipName: 'domain',
  },
  address: {
    header: 'Address',
    group: 'Opportunity Attributes',
    tooltipName: 'address',
  },
  city: {
    header: 'City',
    group: 'Opportunity Attributes',
    tooltipName: 'city',
  },
  state: {
    header: 'State',
    group: 'Opportunity Attributes',
    tooltipName: 'state',
  },
  zipcode: {
    header: 'ZIP Code',
    group: 'Opportunity Attributes',
    tooltipName: 'zipcode',
  },
  country: {
    header: 'Country',
    group: 'Opportunity Attributes',
    tooltipName: 'country',
  },
  phone_number: {
    header: 'Phone Number',
    group: 'Opportunity Attributes',
    tooltipName: 'phone_number',
  },
  extension: {
    header: 'Extension',
    group: 'Opportunity Attributes',
    tooltipName: 'extension',
  },
  chain_size: {
    header: 'Chain Size',
    group: 'Opportunity Attributes',
    tooltipName: 'chain_size',
  },

  // Account-related columns from COMMON_COLUMNS
  ...COMMON_COLUMNS,
} satisfies Partial<
  Record<keyof IDoorProxy | keyof typeof COMMON_COLUMNS, DataTypeColumn>
>
